<template>
  <HomeLayout>
    <div class="card-page">
      <div v-if="!isActive" class="no-data">
        <Result
          :src="require('@/assets/no-order.png')"
          :text="$t('card_no_card_message')"
        >
          <md-button slot="button" type="primary" @click="handleActivate">
            {{ $t("activate_wallet") }}
          </md-button>
        </Result>
      </div>

      <div v-else-if="cardList.length === 0" class="no-data">
        <Result
          :src="require('@/assets/no-order.png')"
          :text="$t('card_no_card_message')"
        >
          <md-button slot="button" type="primary" @click="handleAddNewCard">
            {{
              $t("add_now")
            }}
          </md-button>
        </Result>
      </div>

      <div v-else class="card-list">
        <div class="action-bar">
          {{ $t("add") }}
          <button class="round-button" @click="handleAddNewCard">+</button>
        </div>

        <CardItem
          v-for="(card, index) in cardList"
          :key="index"
          :model="card"
          @click="handleShowAction"
        />
      </div>

      <md-action-sheet
        v-model="showAction"
        :title="$t('view_bank_card_number')"
        :cancel-text="$t('cancel')"
        :options="options"
        :on-selected="handleCardAction"
      />
    </div>
  </HomeLayout>
</template>

<script>
import { Button, ActionSheet } from 'mand-mobile'
import Result from '@/components/Result'
import CardItem from './CardItem'
import { singList } from '@/api/withdraw'
import HomeLayout from '@/layout/HomeLayout'

export default {
  name: 'Card',

  components: {
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    Result,
    CardItem,
    HomeLayout
  },

  data () {
    return {
      showAction: false,
      cardList: [],
      options: [
        {
          label: this.$t('delete_option'),
          value: 0
        }
      ]
    }
  },

  computed: {
    isActive () {
      return this.$store.getters.isActive
    }
  },

  async created () {
    // 如果未激活 就不调用后续接口了
    if (!this.isActive) return

    this.cardList = await singList()
  },

  methods: {
    handleShowAction () {
      // this.showAction = true
    },
    handleCardAction () {},
    handleAddNewCard () {
      this.$router.push({ name: 'CardSelectType' })
    },
    handleActivate () {
      this.$store.commit('change_agreementVisible', true)
    }
  }
}
</script>

<style scoped lang="scss">
.card-page {
  padding: 40px;
}

.action-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 40px;
  font-size: 28px;
  color: #333;
}

.round-button {
  margin-left: 16px;
  height: 72px;
  width: 72px;
  border-radius: 50%;
  border: none;
  background-color: #fff;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
  font-size: 50px;
  outline: none;
}

.no-data {
  margin-top: 120px;
}

.node-data-result {
  height: 558px;
}
</style>
